import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext, useState, useMemo } from 'react';
import classnames from 'classnames';
import { AsyncDataContext } from './AsyncDataContext.js';
import { Loader } from '@hh.ru/magritte-ui-loader';
import { s as styles } from './date-picker-CgUVI9LP.js';

/**
 * Отображает лоадер поверх контента во время загрузки асинхронных данных.
 * В multi-лейауте каждый календарь должен быть обернут в свой лоадер,
 * чтобы календари с уже загруженными данными рендерили их, а не анимацию лоадера
 */
const AsyncDataLoader = ({ children }) => {
    const asyncDataContext = useContext(AsyncDataContext);
    const [isLoading, setLoading] = useState(false);
    const value = useMemo(() => {
        if (!asyncDataContext) {
            return null;
        }
        return {
            ...asyncDataContext,
            startAsyncLoading: (startDate, endDate) => {
                setLoading(true);
                void (async () => {
                    try {
                        await asyncDataContext.awaitAsyncLoading(startDate, endDate);
                    }
                    finally {
                        setLoading(false);
                    }
                })();
            },
        };
    }, [asyncDataContext, setLoading]);
    return (jsxs("div", { className: classnames(styles.datePicker, { [styles.datePickerLoading]: isLoading }), "data-qa": "date-picker", children: [isLoading && (jsx("div", { className: styles.loader, children: jsx(Loader, {}) })), jsx("div", { className: classnames({ [styles.loading]: isLoading }), children: jsx(AsyncDataContext.Provider, { value: value, children: children }) })] }));
};

export { AsyncDataLoader };
//# sourceMappingURL=AsyncDataLoader.js.map
